import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';
import { LilateCardComponent } from '../lilate-card.component';

@Component({
  selector: 'app-lilate-card-pending-assessment',
  templateUrl: './lilate-card-pending-assessment.component.html',
  styleUrls: ['./lilate-card-pending-assessment.component.scss']
})
export class LilateCardPendingAssessmentComponent extends LilateCardComponent {
  @Input() bloc: string;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    )
  }

}
